import { styled } from '@mui/material';

export const VisuallyHiddenInput = styled('input')({
  height: 1,
  width: 1,
  bottom: 0,
  left: 0,
  overflow: 'hidden',
  position: 'absolute',
  whiteSpace: 'nowrap',
});
